module.exports = __webpack_public_path__ + "static/img/login_zjz.1ec802a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_zjz.png
// module id = IxFF
// module chunks = 1